import { render, staticRenderFns } from "./claim-fc.vue?vue&type=template&id=f828884a&scoped=true"
import script from "./claim-fc.vue?vue&type=script&lang=js"
export * from "./claim-fc.vue?vue&type=script&lang=js"
import style0 from "./claim-fc.vue?vue&type=style&index=0&id=f828884a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f828884a",
  null
  
)

export default component.exports